<template>
  <div class="trigger">
    <slot name="content"></slot>
    <span @click="onOpen">
      <slot></slot>
    </span>
    <span v-if="clearable && value && value.length > 0">
      <el-link class="ml-2" type="info" @click="onClearSelection" :underline="false">清空</el-link>
    </span>
    <el-dialog top="0px" append-to-body :close-on-click-modal="false" :title="title" :visible.sync="visible"
      :width="modelWidth" @close="onClose">
      <div>
        <slot name="search" :queryParam="queryParam"></slot>
        <div class="py-2" v-if="multiple">
            <el-alert :title="`当前已选中：${rowKeySelection.length}项记录`" type="info" :closable="false"> </el-alert>
        </div>
        <c-table :max-height="400" :row-class-name="currentRowKey" @row-click="onSelect" :isSelection="multiple"
          :selection.sync="rowKeySelection" :selectRows.sync="rowSelection" :isIndex="false" :data="dataSource"
          :columns="columns" :query.sync="pagintion" :total="total" @loadPage="loadData" ref="table">
        </c-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <template v-if="multiple">
          <el-button size="small" type="primary" @click="onOk">确 定</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import { cloneDeep, debounce } from "lodash";
import emitter from 'element-ui/src/mixins/emitter';
export default {
  props: {
    title: {
      type: String,
      default: () => "请选择"
    },
    value: {
      type: Array | String | Number,
      default: () => []
    },
    url: {
      type: String,
      default: () => ""
    },
    params: {
      type: Object,
      default: () => ({})
    },
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    httpRequest: {
      type: Function | null,
      default: null
    },
    modelWidth: {
      type: String | Number,
      default: "50%"
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  mixins: [initListMinxin, emitter],
  data() {
    return {
      queryParam: {},
      pagintion: {
        page: 1,
        page_size: 50
      },
      visible: false,
      disabledCreated: true,
      // 记录当前列表加载序号，避免旧请求回包覆盖最新筛选结果。
      loadRequestSerial: 0,
      fetchDataEvent: data =>
        this.$common.http({
          url: this.url,
          data: Object.assign(data, this.params),
          noLoading: true
        })
    };
  },
  methods: {
    onClearSelection() {
      this.rowSelection = [];
      this.rowKeySelection = [];
      this.$nextTick(() => {
        this.onOk();
      });
    },
    currentRowKey(row) {
      if (!this.multiple && this.rowKeySelection.includes(row.id)) {
        return "!bg-blue-200 cursor-pointer";
      }
      return "cursor-pointer"
    },
    onOpen() {
      this.initValue();
      this.loadData();
      this.visible = true;
    },
    onOk() {
      // const { selectRows } = this.$refs.table;
      // this.rowSelection = cloneDeep(selectRows);
      this.$emit("change", this.rowKeySelection);
      this.$emit("update:rows", this.rowSelection);
      this.dispatch('ElFormItem', 'el.form.change', [this.value]);
      this.$nextTick(() => {
        this.visible = false;
      });
    },
    onClose() {
      this.rowSelection = [];
      this.rowKeySelection = [];
      this.$emit("close");
    },
    initValue() {
      const v = this.value || [];
      const r = this.rows || [];
      this.rowKeySelection = cloneDeep(v);
      this.rowSelection = cloneDeep(r);
    },
    onSelect(row) {
      if (!this.multiple) {
        if (this.rowKeySelection.includes(row.id)) {
          this.rowKeySelection = [];
          this.rowSelection = [];
        } else {
          this.rowKeySelection = [row.id];
          this.rowSelection = [row];
        }
        this.$nextTick(() => {
          this.onOk();
        });
      }
    },
    /**
     * 只有最后一次加载请求返回的数据才允许刷新列表，
     * 避免弹窗初始化请求比筛选请求更晚返回时覆盖最新结果。
     */
    async loadData() {
      const requestSerial = ++this.loadRequestSerial;
      const data = Object.assign(this.queryParam, this.pagintion)
      if (this.httpRequest) {
        try {
          const resp = await this.httpRequest(Object.assign(data, this.params));
          if (requestSerial !== this.loadRequestSerial) {
            return;
          }
          this.total = resp.total;
          this.dataSource = resp.data;
        } catch (error) {
          console.log(error);
        }
        return;
      }
      if (this.fetchDataEvent) {
        try {
          const dataObj = await this.fetchDataEvent(data);
          if (requestSerial !== this.loadRequestSerial) {
            return;
          }
          this.total = dataObj.data.data.total;
          this.dataSource = dataObj.data.data.data;
        } catch (e) { }
        setTimeout(() => {
          // 只让当前最新的一次加载触发表格后置回调。
          if (requestSerial !== this.loadRequestSerial) {
            return;
          }
          if (this.loadCallBack) {
            this.loadCallBack();
          }
        }, 500);
      }
    }
  },
  computed: {
    paramsString() {
      return JSON.stringify(this.params)
    }
  },
  watch: {
    value: {
      handler() {
        this.initValue();
      },
      deep: true
    },
    paramsString: debounce(function () {
      this.pagintion.page = 1;
      this.loadData();
    }, 300)
  },
  model: {
    prop: "value",
    event: "change"
  },
  mounted() {
    // this.initValue();
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  top: 50%;
  transform: translateY(-50%);
}

/deep/ .el-link {
  vertical-align: top;
}
</style>
